/* Component Dependencies */
var airportTransportationTemplate = require('templates/airportTransportation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'airportTransportation',
  template: {
    'airportTransportation': airportTransportationTemplate
  }
});
